var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientMgmt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-21120 -14833)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 40,
    height: 40,
    transform: "translate(21120 14833)",
    fill: "#0090f0",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(21123 14749.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431",
    transform: "translate(0 92.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4814",
    "data-name": "Path 4814",
    d: "M30.27,102.028a4,4,0,1,0-4.584,0,6.924,6.924,0,0,0-2.361,1.385,8.959,8.959,0,0,0-3.241-1.766,5.062,5.062,0,1,0-5.235,0,9.034,9.034,0,0,0-3.206,1.745,6.98,6.98,0,0,0-2.334-1.357,4,4,0,1,0-4.584,0A7.014,7.014,0,0,0,0,108.663v.457a.03.03,0,0,0,.028.028H8.5a9.314,9.314,0,0,0-.076,1.17v.471a3.683,3.683,0,0,0,3.684,3.684H22.839a3.683,3.683,0,0,0,3.684-3.684v-.471a9.314,9.314,0,0,0-.076-1.17h8.525A.03.03,0,0,0,35,109.12v-.457A7.041,7.041,0,0,0,30.27,102.028Zm-5.18-3.276a2.888,2.888,0,1,1,2.943,2.888h-.111A2.884,2.884,0,0,1,25.09,98.753ZM13.5,97.312a3.954,3.954,0,1,1,4.183,3.947h-.457A3.96,3.96,0,0,1,13.5,97.312Zm-9.391,1.44a2.888,2.888,0,1,1,2.943,2.888H6.939A2.888,2.888,0,0,1,4.107,98.753Zm4.584,9.28H1.122a5.917,5.917,0,0,1,5.831-5.284h.083a5.856,5.856,0,0,1,3.774,1.406A9.093,9.093,0,0,0,8.691,108.033ZM25.4,110.789a2.58,2.58,0,0,1-2.576,2.576H12.091a2.58,2.58,0,0,1-2.576-2.576v-.471a7.955,7.955,0,0,1,7.708-7.943c.076.007.159.007.235.007s.159,0,.235-.007a7.955,7.955,0,0,1,7.708,7.943Zm.824-2.756a9.069,9.069,0,0,0-2.1-3.85,5.884,5.884,0,0,1,3.809-1.434h.083a5.917,5.917,0,0,1,5.831,5.284Z",
    transform: "translate(0 -92.25)",
    fill: "#ffc051"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientMgmt);
export default __webpack_public_path__ + "static/media/clientMgmt.44bc2fb3beff0ddf86033cabbd1e4e40.svg";
export { ForwardRef as ReactComponent };